export const ConfigApp: IConfigApp = {
  endpoints: {
    canApi: process.env.REACT_APP_ENDPOINTS_CAN_API || "",
  },
  scopes: {
    app: [process.env.REACT_APP_SCOPE_APP || ""],
    canApi: [process.env.REACT_APP_SCOPE_CAN_API || ""],
  },
  environment: process.env.REACT_APP_ENVIRONMENT || "",
  disableCosmeticPermissions: process.env.REACT_APP_DISABLE_COSMETIC_PERMISSIONS === "true".toLowerCase() || false,
};

interface IConfigApp {
  endpoints: {
    [key: string]: string;
  };
  scopes: {
    [key: string]: string[];
  };
  environment: string;
  disableCosmeticPermissions: boolean;
}
